import { render, staticRenderFns } from "./DropdownSelector.vue?vue&type=template&id=06c45fac&web=true&"
import script from "./DropdownSelector.vue?vue&type=script&lang=js&"
export * from "./DropdownSelector.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSelector.vue?vue&type=style&index=0&id=06c45fac&prod&lang=css&"
import style1 from "./DropdownSelector.vue?vue&type=style&index=1&id=06c45fac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports